export default "__VITE_ASSET__feb51618__"